import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OriginStory() {
  return <section id="story" className="py-14 md:py-32 bg-charcoal relative" data-id="element-263" data-mp="37kyz7v2mcdqn">
      <div className="max-w-4xl mx-auto px-6" data-id="element-264" data-mp="37j4mh41i3rxn">
        <FadeIn data-id="element-265" data-mp="2tm7lwavkyw3k">
          <p className="text-xs text-sand font-medium uppercase tracking-[0.25em] text-center mb-4" data-id="element-266" data-mp="2tko8cs1b6z5h">
            Quién es Matías
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8 md:mb-12 text-center" data-id="element-267" data-mp="2xovv4jo7i512">
            Historia de origen
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-offwhite-dim leading-relaxed bg-charcoal-dark p-8 md:p-12 rounded-sm border border-charcoal-light" data-id="element-268" data-mp="2onnzyagzlkb7">
          <FadeIn delay={0.1} data-id="element-269" data-mp="2ew0ecq742xhn">
            <p data-id="element-270" data-mp="2exbkgwo14hbx">
              Cerré más de{' '}
              <strong className="text-offwhite font-medium" data-id="element-271" data-mp="20wsbnnbqp78p">
                $2.500.000 USD
              </strong>{' '}
              en ventas de alto ticket. Tenía $10.000 por mes y un estilo de vida
              que desde afuera parecía todo lo que se supone que tenés que
              querer.
            </p>
            <p className="mt-4" data-id="element-272" data-mp="ag1u0jaq6kza">
              Y tres hijas que se iban a dormir solas mientras yo cerraba
              llamadas.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-273" data-mp="od75wzx4ee2g">
            <p className="text-xl md:text-2xl font-heading font-bold text-amber" data-id="element-274" data-mp="jfowz9j3ryug">
              Proveía todo. No estaba en nada.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-275" data-mp="3rtxk422uvxf8">
            <p data-id="element-276" data-mp="3mx70x5vr8lpl">
              Les vendía libertad a otros mientras yo no la tenía. Les decía a
              mis hijas que podían ser y hacer lo que quisieran — mientras yo
              estaba atado a horarios de otro.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-277" data-mp="oead4keu88d">
            <blockquote className="border-l-4 border-sand pl-6 py-2 my-8 text-xl md:text-2xl font-heading font-bold text-offwhite" data-id="element-278" data-mp="395irxbgsydcu">
              El día que renuncié, una de mis hijas me dijo: "podés llorar,
              papi."
            </blockquote>
            <p data-id="element-279" data-mp="182rotqtiiow4">
              No renuncié a los $10.000. Renuncié al contenedor que me quedaba
              chico. Renuncié a esconder el fuego que siento cuando veo a
              alguien transformarse de verdad.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-280" data-mp="1lufyzok7b3ag">
            <p className="text-offwhite font-medium" data-id="element-281" data-mp="1ltmqai1om3po">
              El problema no era lo que hacía. Era la coherencia entre lo que
              pensaba, sentía y hacía.
            </p>
            <p className="mt-4" data-id="element-282" data-mp="u2qelkrcy53z">
              Cuando empecé a trabajar todo al mismo tiempo — cuerpo, mente,
              identidad, familia y propósito — algo se acomodó. La energía se
              estabilizó. El ruido mental bajó. Las relaciones mejoraron.
            </p>
            <p className="mt-6 text-xl text-offwhite font-medium" data-id="element-283" data-mp="29kiobwwqdv5d">
              Y lo más importante: <span className="text-sand" data-id="element-284" data-mp="2ejd4ss7877mb">me reconocí.</span>
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-285" data-mp="2onaef24f3orx">
            <p data-id="element-286" data-mp="2onjt3tk0i9ib">
              ELEVATE nació de esa renuncia. Del mismo proceso que apliqué en mi
              propia vida, y que hoy aplico con las personas que acompaño.
            </p>
            <p className="mt-8 text-2xl font-heading font-bold text-amber text-center" data-id="element-287" data-mp="2ewyx8dvq3j33">
              Cuando volvés a vos, tu casa lo siente.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}